import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { translationJobList } from "../../redux/actions/translationJob";
import moment from "moment";
import Loading from "../../components/ui/loader/loader";
import { availableLanguages } from "../../components/data/language";
import Pagination from "../../components/ui/pagination/pagination";
import errorToast from "../../components/toast/errorToast";
import { LuSearch } from "react-icons/lu";
import PageTableLayout from "../../components/ui/PageTableLayout/PageTableLayout";

const TranslationJob = () => {
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [translationData, setTranslationData] = useState([]);
  const [paginationData, setPaginationData] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterTerm, setFilterTerm] = useState("");

  const dispatch = useDispatch();

  const onSuccess = (data) => {
    setTranslationData(data.data.data.translationJobs);
    setPaginationData(data.data.data.pagination);
    setLoading(false);
  };
  const onError = (data) => {
    errorToast(data.data.message);
  };

  useEffect(() => {
    document.title = 'Translation Jobs - Acumen Translation Hub';
  }, []);

  useEffect(() => {
    setLoading(true);
    dispatch(translationJobList({ page, page_size: rowsPerPage, search: filterTerm }, onSuccess, onError));
  }, [page, rowsPerPage, filterTerm]);

  const getLangName = (value) => {
    let label = null;
    availableLanguages.forEach((itemdata) => {
      if (itemdata.value === value) {
        label = itemdata.label;
      }
    });
    return label;
  };

  return (
    <PageTableLayout
      title="Translation Jobs"
      description={
        <p className="text-start mb-0">
          A translation job is a translation request submitted by a translation user. The following table contains jobs from all translations and users in your project.
        </p>
      }
      filters={
        <div className="input-group mt-2">
          <span className="input-group-text">
            <LuSearch />
          </span>
          <input
            type="text"
            className="input-field w-75"
            placeholder="Enter user email or value"
            value={filterTerm}
            onChange={(e) => setFilterTerm(e.target.value)}
          />
        </div>
      }
      pagination={
        paginationData?.total > 10 ? (
          <Pagination
            data={paginationData}
            nextFunc={() => setPage(page + 1)}
            prevFunc={() => setPage(page - 1)}
            setPageRowFunc={(value) => {
              setPage(1);
              setRowsPerPage(value);
            }}
          />
        ) : null
      }
    >
      <thead>
        <tr className="text-start text-nowrap">
          <th>Name</th>
          <th width={"15%"}>Portal</th>
          <th>Owner Email</th>
          <th>Pages</th>
          <th>Glossary</th>
          <th>State</th>
          <th>Create Time</th>
          <th>Last Updated</th>
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr>
            <td colSpan="8">
              <Loading text={"Loading contents"} style={{ height: "5rem" }} />
            </td>
          </tr>
        ) : translationData?.length > 0 ? (
          translationData.map((item) => (
            <tr key={item.id}>
              <td>
                {(() => {
                  const originalName = item?.file_name || "download";
                  const lastDotIndex = originalName.lastIndexOf(".");

                  const fileName =
                    lastDotIndex !== -1
                      ? originalName.substring(0, lastDotIndex)
                      : originalName;

                  const extension =
                    lastDotIndex !== -1
                      ? originalName.substring(lastDotIndex + 1)
                      : "";

                  return `${fileName}_${getLangName(item?.target_lang)}${extension ? `.${extension}` : ""
                    }`;
                })()}
              </td>
              <td>{item?.portal?.portal_name}</td>
              <td>{item?.owner?.email}</td>
              <td>{item?.no_of_pages}</td>
              <td>{item?.glossary?.name || "N/A"}</td>
              <td>{item?.status ? "SUCCEEDED" : "PENDING"}</td>
              <td>{moment(item?.createdAt).format('MM/DD/YY, hh:mm A')}</td>
              <td>{moment(item?.updatedAt).format('MM/DD/YY, hh:mm A')}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="8">No Rows to display</td>
          </tr>
        )}
      </tbody>
    </PageTableLayout>
  );
};

export default TranslationJob;
